<template>
    <div class="bg-dark" style="padding-right: 40px;">
        <div class="row items-center no-wrap justify-between bg-dark">
            <router-link :to="'/'"><img src="../../img/identity/logo-pocket.png" :alt="appName" class="logo"></router-link>

            <div class="col-auto row items-center">
                <!-- <ul class="gt-sm">
                    <li v-for="menu in menus" :key="menu.name"><router-link :to="menu.slug" class="text-white uppercase">{{ $T(menu.name) }}</router-link></li>
                </ul> -->

                <div v-if="multilingue" class="gt-sm">
                    <ul>
                        <li class="lang pt">
                           <router-link to="/lang/pt/*">pt</router-link>
                        </li>
                        <li class="lang es">
                            <router-link to="/lang/es/*">es</router-link>
                        </li>
                    </ul>
                </div>
                <q-btn round size="sm" color="primary" icon="menu" class=""
                       @click="$emit('rightDrawerToogle')"></q-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {
        QBtn,
        QPopover,
        QList,
        QItem
    } from 'quasar-framework'
    import Spinner from "./spinner/Spinner"

    export default {
        data: () => ({
            appName: window.config.appName,
            language: window.config.locale,
            multilingue: window.config.multilingue,
            redirect: '',
            enabledLanguages: window.config.enabled_locales
        }),

        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),

            menus() {
                this.redirect = '/'+this.$route.path.split('/').join('*')
                return window.config.menus
            }
        },

        components: {
            Spinner,
            QBtn,
            QPopover,
            QList,
            QItem
        },

        methods: {
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                this.$router.push("/").catch(()=>{})
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Header.vue